var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFullIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 1.66858C14.6017 1.66858 18.3327 5.39954 18.3327 10.0019C18.3327 14.6043 14.6017 18.3352 9.99935 18.3352C5.39698 18.3352 1.66602 14.6043 1.66602 10.0019C1.66602 5.39954 5.39698 1.66858 9.99935 1.66858ZM12.7434 6.91266L8.33268 11.3234L7.25527 10.246C6.92983 9.92055 6.4022 9.92055 6.07676 10.246C5.75132 10.5714 5.75132 11.0991 6.07676 11.4245L7.74343 13.0912C8.06886 13.4166 8.5965 13.4166 8.92194 13.0912L13.9219 8.09117C14.2474 7.76573 14.2474 7.23809 13.9219 6.91266C13.5965 6.58722 13.0689 6.58722 12.7434 6.91266Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFullIcon);
export default __webpack_public_path__ + "static/media/arrowFullIcon.e434ef3d.svg";
export { ForwardRef as ReactComponent };